import * as React from "react";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { PercentageOrMoney } from "../../../../../../Shared/PercentageOrMoney/PercentageOrMoney";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { SectionHeader } from "../../../NewBusinessWizard/Components/SharedComponents";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SourceTypeArray, SourceTypeMap } from "../../Resource/Contents";
import { SourceType } from "../../../../../../../Wrap/Constants/Enums/Domain/SourceType";
import { DrawdownModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { MoneyOrPercentage } from "../../../../../../../Wrap/Models/Models/Shared/MoneyOrPercentage";
import { PensionBase } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/PensionBase";
import { ProductDetailsStore } from "../../../../../Stroes/Variable";
import { calculateNetDrawdownValue, getCrystallisationAmount } from "./Helper/DrawdownDetailHelper";
import { MoneyOrPercentageType } from "../../../../../../../Wrap/Constants/Enums/MoneyOrPercentageType";

interface IDIACProps extends IProcessComponentProps {
    data: DrawdownModel;
    modelData: PensionBase;
    onChange: (changes) => void;
    existingAccount: boolean;
}

interface IDIACState {
    wrapcashCurrentTotal: number;
}

export class DIAC extends ProcessComponent<IDIACProps, IDIACState> {
    constructor(props: any) {
        super(props);
        this.state = {
            wrapcashCurrentTotal: ProductDetailsStore.getSubAccount(SubAccountType.WrapCash)?.TotalValue?.Amount,
        };
        this.subscribeToStore(ProductDetailsStore, () => this.onProductDetailsChange());
    }

    private onProductDetailsChange() {
        const { existingAccount } = this.props;
        if (existingAccount && !this.state.wrapcashCurrentTotal) {
            const result = ProductDetailsStore.getSubAccount(SubAccountType.WrapCash);
            if (result) {
                this.setState({
                    wrapcashCurrentTotal: result.TotalValue?.Amount,
                });
            }
        }
    }

    componentDidMount() {
        super.componentDidMount();
        if (!this.props.data?.DrawdownAdviserCharge?.DrawdownInitialAdviserCharge?.SourceType) {
            const charge = {
                ...this.props.data?.DrawdownAdviserCharge?.DrawdownInitialAdviserCharge,
                SourceType: SourceType.ProductCash,
            };
            this.onDataChange(
                this.props.onChange,
                { DrawdownInitialAdviserCharge: charge },
                this.props.data,
                "DrawdownAdviserCharge"
            );
        }
    }

    validateSufficientProductCashForDIAC(total: number) {
        const { data, existingAccount } = this.props;
        const diac = data?.DrawdownAdviserCharge?.DrawdownInitialAdviserCharge;
        if (diac?.SourceType == SourceType.ProductCash) {
            return true;
        }
        if (existingAccount) {
            const v = diac?.Type == MoneyOrPercentageType.Money ? diac?.Money?.Amount : diac?.Percentage * total;
            return v <= this.state.wrapcashCurrentTotal;
        } else {
            return true;
        }
    }

    public render(): JSX.Element {
        const { data, onChange, modelData } = this.props;
        const netDrawdownValue = calculateNetDrawdownValue(data, modelData?.PensionProtection) * 0.9999;
        const totalforEstimation = getCrystallisationAmount(data);
        const adviserCharge: MoneyOrPercentage = data?.DrawdownAdviserCharge?.DrawdownInitialAdviserCharge;

        return (
            <>
                <h2 className="mb-22">Adviser charges</h2>
                {SectionHeader("Drawdown initial adviser charge", "Content TBC")}
                <PercentageOrMoney
                    label="Rate"
                    data={adviserCharge}
                    onChange={(v) => {
                        const charge = { ...adviserCharge, ...v };
                        this.onDataChange(
                            onChange,
                            { DrawdownInitialAdviserCharge: charge },
                            data,
                            "DrawdownAdviserCharge"
                        );
                    }}
                    onRef={(ref) => this.appendChild(ref)}
                    totalForEstimation={totalforEstimation}
                    cssPercentageOrMoneyClasses="control-size-100 mb-36"
                    validationRules={[
                        {
                            errorMessage: " Value entered cannot be greater than the net drawdown value",
                            validator: (v) => {
                                return data?.DrawdownAdviserCharge?.DrawdownInitialAdviserCharge?.SourceType ==
                                    SourceType.WrapCash
                                    ? true
                                    : !v || v <= netDrawdownValue;
                            },
                        },
                    ]}
                />
                <RadiosEditor
                    cssWrapper="rg-inline mb-16"
                    label="Take the charge from"
                    selected={adviserCharge?.SourceType}
                    options={SourceTypeArray}
                    getText={(v) => {
                        return SourceTypeMap[v];
                    }}
                    onChange={(v) => {
                        const charge = { ...adviserCharge, SourceType: v };
                        this.onDataChange(
                            onChange,
                            { DrawdownInitialAdviserCharge: charge },
                            data,
                            "DrawdownAdviserCharge"
                        );
                    }}
                    required="Please choose "
                />
                {!this.validateSufficientProductCashForDIAC(netDrawdownValue) && (
                    <Alert
                        alertType={AlertType.Warning}
                        message="There is insufficient cash to pay the Drawdown Initial Adviser Charge(s) requested"
                    />
                )}
                {adviserCharge?.SourceType === SourceType.WrapCash && (
                    <Alert alertType={AlertType.Warning} message="SL TO CONFIRM MESSAGE TO DISPLAY IN CONTENT REVIEW" />
                )}
            </>
        );
    }
}
